(function () {
	const DPD = {
		TEMPLATE_CLASS: 'dpd-parcelshop-container',
		RADIO_SELECTOR: 'input[type="radio"][id*="wc_dpd_parcelshop"]',
		DESCRIPTION_CART_GROUP_SELECTOR:
			'.wc-block-components-radio-control__description-group',
		DESCRIPTION_CHECKOUT_GROUP_SELECTOR:
			'.wc-block-components-radio-control__option-layout',
	};

	function findDpdRadios() {
		const selectors = [
			'input[type="radio"][id*="wc_dpd_parcelshop"]',
			'input[type="radio"][value*="dpd_parcelshop"]',
			'input[type="radio"][name*="dpd_parcelshop"]',
		];

		const allRadios = [];
		selectors.forEach((selector) => {
			const radios = document.querySelectorAll(selector);
			if (radios.length > 0) {
				Array.prototype.push.apply(allRadios, radios);
			}
		});

		return allRadios;
	}

	function addTemplates() {
		const radios = findDpdRadios();
		if (radios.length === 0) {
			setTimeout(addTemplates, 1000);
			return;
		}

		// Get template content from the hidden div
		const templateSource = document.getElementById('dpd-template-source');
		if (!templateSource) {
			console.error('DPD Parcelshop template source not found');
			return;
		}

		const templateContent = templateSource.innerHTML;
		if (!templateContent) {
			console.error('DPD Parcelshop template content not available');
			return;
		}

		radios.forEach((radio) => {
			const container = radio.closest(
				'.wc-block-components-radio-control__option'
			);
			if (!container) return;

			const descCartGroup = container.querySelector(
				DPD.DESCRIPTION_CART_GROUP_SELECTOR
			);
			const descCheckoutGroup = container.querySelector(
				DPD.DESCRIPTION_CHECKOUT_GROUP_SELECTOR
			);
			if (!descCartGroup && !descCheckoutGroup) return;

			if (
				descCartGroup &&
				descCartGroup.querySelector('.' + DPD.TEMPLATE_CLASS)
			)
				return;
			if (
				descCheckoutGroup &&
				descCheckoutGroup.querySelector('.' + DPD.TEMPLATE_CLASS)
			)
				return;

			const template = document.createElement('div');
			template.className = DPD.TEMPLATE_CLASS;
			template.innerHTML = templateContent;

			if (descCartGroup) {
				descCartGroup.appendChild(template);
			}

			if (descCheckoutGroup) {
				descCheckoutGroup.appendChild(template);
			}
		});
	}

	function initialize() {
		// Check if we should run (set by wp_localize_script)
		if (
			typeof wc_dpd_parcelshop_block_settings === 'undefined' ||
			!wc_dpd_parcelshop_block_settings.ready
		) {
			return;
		}

		addTemplates();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initialize);
	} else {
		initialize();
	}
})();
